import {useEffect} from "react";
import {Control, Controller} from "react-hook-form";
import {Calendar} from "primereact/calendar";
import {classNames} from "primereact/utils";
import "./DateInput.scss";
import {RequestType} from "../../models/Request";

export interface DateInputProps {
    id: string;
    value: Date | null;
    onValueChange: (property: string, value: Date | null) => void;
    labelText: string;
    placeholderText: string;
    showTime?: boolean;
    timeOnly?: boolean;
    icon?: string;
    minDate?: Date;
    maxDate?: Date;
    control: Control;
    setValue?: any;
    errors: any;
    rules?: any;
    disabled?: boolean;
    colorType?: string;
};

export const DateInput = (p: DateInputProps) => {
    const {
        id,
        value,
        onValueChange,
        labelText,
        placeholderText,
        showTime,
        timeOnly,
        icon,
        minDate,
        maxDate,
        control,
        setValue,
        errors,
        rules,
        disabled,
        colorType
    } = p;

    useEffect(() => {
        if (setValue) setValue(labelText, value)
    }, [value]);

    return (
        <div className="date-input">
            {(labelText != '') &&
                <label
                    className={classNames("date-label", {
                        'p-error': errors[labelText], 
                    })}
                    htmlFor={id}
                >
                    {labelText}
                </label>
            }
            <Controller
                name={labelText}
                control={control}
                rules={rules}
                render={({ field, fieldState }) => (
                    <Calendar
                        {...field}
                        id={id}
                        value={value as Date}
                        onChange={(e)=>{
                            field.onChange(e);
                            onValueChange(id, e.value as Date)}}
                            className={classNames(
                                { 'date-input-field' : colorType === undefined },
                                { 'date-input-field-request-import': colorType === RequestType.Import },
                                { 'date-input-field-request-export': colorType === RequestType.Export },
                                { 'date-input-field-request-relocation': colorType === RequestType.Relocation },
                                { 'p-invalid': fieldState.invalid }
                            )}
                        placeholder={placeholderText}
                        showTime={showTime}
                        timeOnly={timeOnly}
                        dateFormat="dd.mm.yy."
                        icon={icon}
                        minDate={minDate}
                        maxDate={maxDate}
                        showIcon
                        disabled={disabled}
                    />
                )}
            />
        </div>
    );
};